// import dashboard from './dashboard';
import logs from './logs';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [logs]
};

export default menuItems;
